import { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from './common/AnimatedSection';
import { Building2, Sofa, HardHat, Layers, ClipboardList, Wrench, Box, TreePine } from 'lucide-react';

const serviceList = [
  { num: '01', slug: 'architectural-design',  icon: Building2,    title: 'Architectural Design',    desc: 'Innovative, functional architectural solutions that reflect identity, purpose, and long-term value.' },
  { num: '02', slug: 'interior-design',        icon: Sofa,         title: 'Interior Design',          desc: 'Thoughtfully crafted environments that balance aesthetics, comfort, and functionality.' },
  { num: '03', slug: 'construction',           icon: HardHat,      title: 'Construction',             desc: 'Professional execution with focus on quality, durability, efficiency, and precision detail.' },
  { num: '04', slug: 'engineering',            icon: Layers,       title: 'Engineering Consultancy',  desc: 'Integrated solutions ensuring structural performance, safety, and technical excellence.' },
  { num: '05', slug: 'project-management',     icon: ClipboardList,title: 'Project Management',       desc: 'End-to-end coordination and supervision from concept development to project completion.' },
  { num: '06', slug: 'renovation',             icon: Wrench,       title: 'Renovation & Remodeling',  desc: 'Modern transformation of existing spaces through strategic redesign and construction improvement.' },
  { num: '07', slug: '3d-visualization',       icon: Box,          title: '3D Visualization',         desc: 'High-quality architectural renderings that bring concepts to life before construction begins.' },
  { num: '08', slug: 'landscape-design',       icon: TreePine,     title: 'Landscape Design',         desc: 'Outdoor environments designed to enhance beauty, usability, and harmony with architecture.' },
];

function ServiceCard({ service }) {
  const [hovered, setHovered] = useState(false);
  const Icon = service.icon;

  return (
    <Link
      to={`/services/${service.slug}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'block',
        background: hovered ? '#111a1a' : '#0b1d1d',
        padding: '44px 32px',
        position: 'relative',
        overflow: 'hidden',
        textDecoration: 'none',
        transition: 'background 0.4s',
      }}
    >
      {/* Bottom teal accent line */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '2px',
          background: '#0f9d94',
          transformOrigin: 'left',
          transform: hovered ? 'scaleX(1)' : 'scaleX(0)',
          transition: 'transform 0.4s cubic-bezier(0.77,0,0.175,1)',
        }}
      />

      {/* Number */}
      <p
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '52px',
          color: hovered ? 'rgba(15,157,148,0.28)' : 'rgba(15,157,148,0.1)',
          fontWeight: 300,
          lineHeight: 1,
          marginBottom: '20px',
          transition: 'color 0.4s',
        }}
      >
        {service.num}
      </p>

      {/* Icon — top right */}
      <div
        style={{
          position: 'absolute',
          top: '36px',
          right: '32px',
          width: '36px',
          height: '36px',
          border: '1px solid rgba(15,157,148,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon size={15} color={hovered ? '#0f9d94' : '#0a6f69'} strokeWidth={1.3} />
      </div>

      {/* Name */}
      <p
        style={{
          fontSize: '11px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          color: '#f4f8f8',
          marginBottom: '12px',
          fontWeight: 600,
        }}
      >
        {service.title}
      </p>

      {/* Description */}
      <p
        style={{
          fontSize: '12px',
          lineHeight: 1.8,
          color: '#9eb2b2',
        }}
      >
        {service.desc}
      </p>
    </Link>
  );
}

function Services() {
  return (
    <AnimatedSection
      id="services"
      style={{ background: '#0b1d1d', padding: '100px 0' }}
    >
      {/* Section header */}
      <div style={{ textAlign: 'center', marginBottom: '72px', padding: '0 56px' }}>
        <p
          style={{
            fontSize: '9px',
            letterSpacing: '5px',
            textTransform: 'uppercase',
            color: '#0f9d94',
            marginBottom: '16px',
          }}
        >
          What We Offer
        </p>
        <h2
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(32px, 4vw, 60px)',
            fontWeight: 300,
            color: '#f4f8f8',
            lineHeight: 1.05,
          }}
        >
          End-to-End <em style={{ fontStyle: 'italic', color: '#0f9d94' }}>Design</em>
          <br />& Build Excellence
        </h2>
      </div>

      {/* Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: '1px',
          background: 'rgba(15,157,148,0.1)',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        {serviceList.map((service) => (
          <ServiceCard key={service.slug} service={service} />
        ))}
      </div>
    </AnimatedSection>
  );
}

export default Services;
